import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "secondary";

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: "bg-accent text-white hover:bg-podpink-600 focus-visible:outline-accent",
  secondary:
    "border border-border text-text-secondary hover:bg-surface-2 focus-visible:outline-neutral-400",
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
}

/**
 * The app's button.
 *
 * `type` defaults to "button" rather than the HTML default of "submit", because a button inside a
 * form that was not meant to submit it is a bug that only shows up once a form exists around it.
 */
export function Button({
  variant = "secondary",
  fullWidth = false,
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`rounded-md px-4 py-2 text-sm font-medium transition-colors
                  focus-visible:outline-2 focus-visible:outline-offset-2
                  disabled:cursor-not-allowed disabled:opacity-50
                  ${fullWidth ? "w-full" : ""} ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    />
  );
}
